<template>
  <div style="margin: 8px 32px 24px;">
    <div style="display: flex; align-items: center; justify-content: space-between">
      <el-descriptions title="客户信息" border :column="1" size="small" style="width: 50%">
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="主人" >{{ userForm.name }}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="性别" >{{ userForm.sex == 1?'男':userForm.sex == 2?'女':'未知' }}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="手机号" >{{ userForm.phone }}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="门店" >{{ userForm.shopName}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="总余额" border :column="1" size="small" style="width: 50%">
        <template #title>
          <p>总余额：<span v-if="userForm.userWallet" style="color: #3a8ee6">{{ userForm.userWallet.balanceSumAll }}<span class="giveFont" v-if="userForm.userWallet.balanceSumAll">（{{userForm.userWallet.balanceSum}} + {{userForm.userWallet.balanceSumGive}}）</span></span></p>
        </template>
        <div v-if="userForm.userWallet">
          <el-descriptions-item label-class-name="my-label" class-name="my-item" label="500账户">{{ userForm.userWallet.balanceSumOne}}<span class="giveFont" v-if="userForm.userWallet.balanceSumOne">（{{ userForm.userWallet.balanceOne}} + {{userForm.userWallet.balanceOneGive}}）</span></el-descriptions-item>
          <el-descriptions-item label-class-name="my-label" class-name="my-item" label="1000账户">{{ userForm.userWallet.balanceSumTwo}}<span class="giveFont"  v-if="userForm.userWallet.balanceSumTwo">（{{ userForm.userWallet.balanceTwo}} + {{userForm.userWallet.balanceTwoGive}}）</span></el-descriptions-item>
          <el-descriptions-item label-class-name="my-label" class-name="my-item" label="1500账户">{{ userForm.userWallet.balanceSumThree}}<span class="giveFont"  v-if="userForm.userWallet.balanceSumThree">（{{ userForm.userWallet.balanceThree}} + {{userForm.userWallet.balanceThreeGive}}）</span></el-descriptions-item>
          <el-descriptions-item label-class-name="my-label" class-name="my-item" label="2500账户">{{ userForm.userWallet.balanceSumFour}}<span class="giveFont"  v-if="userForm.userWallet.balanceSumFour">（{{ userForm.userWallet.balanceFour}} + {{userForm.userWallet.balanceFourGive}}）</span></el-descriptions-item>
        </div>
      </el-descriptions>
    </div>

    <div style="margin-top: 24px;">
      <p class="title">支付方式</p>
      <div class="content-box">
        <el-form ref="formRef" :model="userForm" label-width="90px" label-position="left">
          <div class="pay-top">

            <el-form-item :label="type == 1?'预约宠物：':'服务宠物：'">
              <el-checkbox-group v-model="checkList">
                <div v-for="item of petList" :key="item.id">
                  <el-checkbox :label="item.id" >
                    {{item.petBreedColorName}}{{item.woolState == 1?'短毛':item.woolState == 2?'长毛':''}}（{{item.name}}）<span v-if="item.petAgeMonth">{{item.petAgeMonth.age}}岁{{item.petAgeMonth.month}}个月</span>（{{item.sex == 1?'弟弟':item.sex == 2?'妹妹':'未知'}}）{{item.neuteringState == 1?'已绝育':item.neuteringState == 2?'未绝育':'未知'}}
                    <span v-if="item.exemptionDesc" style="color: red; font-size: 12px">*{{item.exemptionDesc}}</span>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="支付门店：">
              <span v-if="type == 1 || userForm.type == 1">{{shopName}}</span>
              <el-select v-else v-model="shopId" placeholder="Select" style="width: 25em" :disabled="preBookId != 0 || idx > -1">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="消费项目：" v-if="proContent">
              {{proContent}}
            </el-form-item>


          </div>

          <div class="pay-main">
<!--            <el-form-item label="抵扣金额：" v-if="idx > -1">-->
<!--              &lt;!&ndash;            <el-input v-model="payDetailForm.deductionMoney" placeholder="请输入金额" style="width: 13.1em; margin-right: 16px;" disabled/>&ndash;&gt;-->
<!--              <p style="color: red;">*上次保存的充值抵扣金额：{{payDetailForm.deductionMoney}}</p>-->
<!--            </el-form-item>-->
            <el-form-item>
              <template #label><span style="font-weight: bold">充值抵扣：</span></template>
              <el-input v-model="deductionMoney" placeholder="请输入金额" style="width: 25em"/>
            </el-form-item>
            <el-form-item>
              <template #label><span style="font-weight: bold">网上支付：</span></template>
              <div style="display: flex; align-items: center; cursor:pointer;" @click="addPayment">
                <ElIcons name="CirclePlusFilled" color="#409EFF" :size="20"/>
                <el-button type="text" style="margin-left: 10px;">添加记录</el-button>
              </div>
            </el-form-item>
            <div v-if="onlinePaymentList.length > 0" style="margin-bottom: 24px;">
              <div v-for="(item,index) of onlinePaymentList" :key="index" class="pay-item">
                <div class="delBtn" @click="delPayment(index)"><ElIcons name="SemiSelect" color="#ffffff" :size="10"/></div>
                <div style="margin: 0 12px;">
                  <!--                  方式：<el-input v-model="item.name" placeholder="请填写" style="width: 8em;"/>-->
                  方式：
                  <el-select v-model="item.type" placeholder="请选择" style="width: 11em">
                    <el-option v-for="item in paymentTypeArray" :key="item.type" :label="item.name" :value="item.type">
                    </el-option>
                  </el-select>
                </div>
                <div>金额：<el-input v-model="item.money" placeholder="请填写" style="width: 11em"/></div>
              </div>

            </div>
<!--            <el-form-item label="支付结算：">-->
<!--              <div style="display: flex; flex-wrap: wrap;">-->
<!--                <p>抵扣<span class="payNum">{{ dedMoney }}</span>元，&nbsp;&nbsp;</p>-->
<!--                <p>支付<span class="payNum">{{ payMoney }}</span>元，&nbsp;&nbsp;</p>-->
<!--                <p>总额<span class="payNum">{{ allPayMoney }}</span>元</p>-->
<!--              </div>-->
<!--            </el-form-item>-->
            <div class="pay-sum">
              <div style="display: flex; flex-wrap: wrap;">
<!--                <p>支付结算：</p>-->
                <p>抵扣<span class="payNum">{{ dedMoney }}</span>元，&nbsp;&nbsp;</p>
                <p>支付<span class="payNum">{{ payMoney }}</span>元，&nbsp;&nbsp;</p>
                <p>总额<span class="payNum">{{ allPayMoney }}</span>元</p>
              </div>
            </div>

          </div>

        </el-form>
      </div>
    </div>
    <div class="dialog-footer" style="text-align: center; margin-top: 8px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">保存</el-button>
    </div>
  </div>
</template>

<script>
import { addOrUpdatePaymentDetail, listOnlinePaymentType} from '@/api/url'
import {getFormData, postJson} from "@/api/api";
import { negativeDecimal } from '@/assets/shared/reg-constant'
import {add} from "@/assets/shared/util";

export default {
  name: "EditPaymentDialog",
  props: {
    value: Object
  },
  data() {
    return {
      idx: this.value.idx,
      userForm: this.value.userForm,
      // userId: this.value.userId,
      payDetailForm: this.value.payDetailForm,
      onlinePaymentList: this.value.payDetailForm.onlinePaymentList?this.value.payDetailForm.onlinePaymentList:[],
      petList: this.value.petList,
      checkList: [],
      preBookPetList: this.value.preBookPetList,
      deductionMoney: this.value.payDetailForm.deductionMoney?this.value.payDetailForm.deductionMoney:'',
      preBookId: this.value.preBookId?this.value.preBookId:0,
      type: this.value.type?this.value.type:0,

      shopId: this.value.shopId,
      shopName: this.value.shopName,
      shopIdArray: JSON.parse(sessionStorage.getItem('ownShopList')).filter(item => item.isEdit == 1),

      paymentTypeArray: [],

      proContent: this.value.proContent,
      totalMoney: this.value.totalMoney,
    }
  },
  computed:{
    dedMoney() {
      let dMoney = Number(this.deductionMoney)
      return dMoney.toFixed(2)
    },
    payMoney(){
      let money = 0
      this.onlinePaymentList.map(item => {
        money += Number(item.money)
      })
      return money.toFixed(2)
    },
    allPayMoney() {
      let allMoney = Number(this.deductionMoney) + Number(this.payMoney)
      return allMoney.toFixed(2)
    },
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    summit() {
      if(this.checkList.length == 0 && this.preBookId > 0 && this.type != 2) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先勾选需要预约的宠物',
          type: 'warning'
        });
        return false
      }
      if(this.onlinePaymentList.length == 0 && this.idx == -1 && !this.deductionMoney) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请添加支付记录或填写抵扣金额',
          type: 'warning'
        });
        return false
      }
      if(this.deductionMoney && !negativeDecimal.test(this.deductionMoney)){
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入正确的抵扣金额',
          type: 'warning'
        });
        return false
      }
      let sumMoney = 0
      if(this.deductionMoney) {
        sumMoney = add([sumMoney, this.deductionMoney])
      }
      if(this.onlinePaymentList.length > 0) {
        for(let i=0; i<this.onlinePaymentList.length; i++) {
          if(!this.onlinePaymentList[i].type || !this.onlinePaymentList[i].money){
            this.$message({
              showClose: true,
              duration: 2000,
              message: '支付方式或金额不能为空',
              type: 'warning'
            });
            return false
          }else if(!negativeDecimal.test(this.onlinePaymentList[i].money)){
            this.$message({
              showClose: true,
              duration: 2000,
              message: '请输入正确的金额',
              type: 'warning'
            });
            return false
          }else {
            sumMoney = add([sumMoney, this.onlinePaymentList[i].money])
          }
        }
      }
      if(this.totalMoney != sumMoney){
        console.log(this.totalMoney)
        console.log(sumMoney)
        this.$message({
          showClose: true,
          duration: 2000,
          message: '支付总额需与消费项目总额保持一致',
          type: 'warning'
        });
        return false
      }


      let param = {}
      param['id'] = this.preBookId?this.preBookId:0;
      param['userId'] = this.userForm.id;
      param['deductionMoney'] = this.deductionMoney?this.deductionMoney:0;
      // param['preBookId'] = this.preBookId;
      // param['petIdArr'] = this.checkList;
      let arr = []
      this.checkList.map(item => {
        let obj = {}
        for(let i=0; i<this.petList.length; i++) {
          if(item == this.petList[i].id) {
            obj.id = this.petList[i].id
            obj.weight = this.petList[i].weight
          }
        }
        arr.push(obj)
      })
      param['petList'] = arr;
      param['shopId'] = this.shopId;
      param['onlinePaymentList'] = this.onlinePaymentList;
      postJson(addOrUpdatePaymentDetail, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', data.data)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    addPayment() {
      let obj = {id: 0, type: '', money: ''}
      this.onlinePaymentList.push(obj)
    },
    delPayment(idx) {
      this.onlinePaymentList.splice(idx, 1)
    },


    getPaymentType() {
      getFormData(listOnlinePaymentType).then((data) => {
        if(data.code == 200) {
          this.paymentTypeArray = data.data
        }
      })
    }

  },
  mounted() {
    // if(this.idx > -1) {
    //   for(let i=0; i<this.payDetailForm.petIdList.length; i++) {
    //     for(let j=0; j<this.userForm.petList.length; j++) {
    //       if(this.payDetailForm.petIdList[i] == this.userForm.petList[j].id) {
    //         this.checkList.push(this.userForm.petList[j].id)
    //       }
    //     }
    //   }
    // }
    // this.userForm.userWallet.balanceSum = add([this.userForm.userWallet.balanceOne, this.userForm.userWallet.balanceTwo, this.userForm.userWallet.balanceThree, this.userForm.userWallet.balanceFour])
    this.userForm.userWallet.balanceSum = add([this.userForm.userWallet.balanceOne, this.userForm.userWallet.balanceTwo, this.userForm.userWallet.balanceThree, this.userForm.userWallet.balanceFour])
    this.userForm.userWallet.balanceSumGive = add([this.userForm.userWallet.balanceOneGive, this.userForm.userWallet.balanceTwoGive, this.userForm.userWallet.balanceThreeGive, this.userForm.userWallet.balanceFourGive])
    this.userForm.userWallet.balanceSumAll = add([this.userForm.userWallet.balanceSum, this.userForm.userWallet.balanceSumGive])
    this.userForm.userWallet.balanceSumOne = add([this.userForm.userWallet.balanceOne, this.userForm.userWallet.balanceOneGive])
    this.userForm.userWallet.balanceSumTwo = add([this.userForm.userWallet.balanceTwo, this.userForm.userWallet.balanceTwoGive])
    this.userForm.userWallet.balanceSumThree = add([this.userForm.userWallet.balanceThree, this.userForm.userWallet.balanceThreeGive])
    this.userForm.userWallet.balanceSumFour = add([this.userForm.userWallet.balanceFour, this.userForm.userWallet.balanceFourGive])
    if(!this.shopId) {
      if(this.shopIdArray.some(e => e.id == this.userForm.shopId)) {
        this.shopId = this.userForm.shopId
      }else {
        this.shopId = this.shopIdArray[0].id
      }
    }
    this.getPaymentType()
    // this.preBookPetList.map(pet => {
    //   this.checkList.push(pet.petId)
    // })

    this.petList.map(item => {
      item.weight = ''
      this.preBookPetList.map(pet => {
        if(pet.petId == item.id) {
          item.weight = pet.weight
          this.checkList.push(pet.petId)
        }
      })
    })

  },
}
</script>

<style scoped>
.title {
  font-weight: bold;
  color: #303133;
}
.content-box {
  border: 1px solid #ebeef5;
  padding: 24px 0 16px;
  /*display: flex;*/
  /*flex-direction: column;*/
  /*align-items: center;*/
  margin-top: 12px;
  /*cursor: pointer;*/
  /*font-size: 13px;*/
  /*border-radius: 16px;*/
  background-color: #ffffff;
}

.pay-top {
  margin: 0 80px 16px;
}

.pay-main {
  background-color: #f7f9fc;
  margin: 32px 40px 16px;
  padding: 32px 40px 16px;
  border-radius: 16px;
}

.pay-sum {
  border-top: 1px solid #e8e8e8;
  padding: 16px 0;
  font-size: 13px;
}

.pay-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.delBtn {
  background-color: #bbbbbb;
  color: #ffffff;
  height: 18px;
  width: 18px;
  border-radius: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 10px;
  cursor: pointer;
}
.delBtn:hover {
  background-color: red;
}
.payNum {
  /*font-size: 16px;*/
  font-weight: bold;
  margin: 0 4px;
}

</style>
